import { ACTIONS_NAMESPACE as CB_ACTIONS_NAMESPACE } from '../constants';

export const ACTIONS_NAMESPACE = `${CB_ACTIONS_NAMESPACE}/WF`;

export const MOUNT_POINT = 'workflow';
